//Vite doesn't polyfill Node's "assert" module for the browser (unlike the old webpack/CRA setup), so this is a local equivalent

export default function assert(value: unknown, message?: string): asserts value {
  if (!value) throw new Error(message ?? "Assertion failed");
}
